<script setup>
const { options } = defineProps({
  options: Object,
});

const emits = defineEmits(["onChange"]);

const selected = ref();
const otherText = ref("");

const onSelectChange = (value) => {
  let reason = value;
  if (value === "Other") reason = null;
  emits("onChange", reason);
};

const onTextChange = (value) => {
  emits("onChange", value);
};
</script>

<template>
  <div class="my-2 px-2">
    <p class="text-sm mb-1 font-medium">Select a reason</p>
    <Select
      v-model="selected"
      :options="options"
      optionLabel="label"
      optionValue="value"
      placeholder="Select one"
      class="w-full"
      @value-change="onSelectChange"
    />
    <Textarea
      v-if="selected === 'Other'"
      v-model="otherText"
      :rows="4"
      class="w-full mt-2"
      placeholder="Add a comment"
      @value-change="onTextChange"
    ></Textarea>
  </div>
</template>
